import {createAction, props} from '@ngrx/store';
import { InstallationDashboardModel } from '../../../core/models/installation-dashboard.model';

export const getInstallationDashboardsByUnitId = createAction(
  '[Core] Get Installation Dashboards By Unit Id',
  props<{unitIds: number[]}>()
);

export const getInstallationDashboardsByUnitIdSuccess = createAction(
  '[Core/API] Get Installation Dashboards By Unit Id Success',
  props<{data: Map<number, any>}>()
);

export const getInstallationDashboardsByUnitIdFailure = createAction(
  '[Core/API] Get Installation Dashboards By Unit Id Failure',
  props<{error: any}>()
);

export type InstallationDashboardsActionsUnion = ReturnType<
  typeof getInstallationDashboardsByUnitId |
  typeof getInstallationDashboardsByUnitIdSuccess |
  typeof getInstallationDashboardsByUnitIdFailure
  >;
